import { render } from "./links-action.vue?vue&type=template&id=1d9d2946"
import script from "./links-action.vue?vue&type=script&lang=js"
export * from "./links-action.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__